<template>
<div>
  <div class="form-error p-2 border-radius" v-if="versionIsNewer">
    {{ $t('versionIsTooOld', {version, projectName})}}
  </div>
</div>
</template>

<script>
import {compareVersion} from "@/utils";
export default {
  name: "ProjectVersionChecker",
  props: {
    projectId: {type: String, required: true},
    versionNumber: {type: String, required: true},
    projectName: {type: String, required: true},
  },
  data() {
    return {
      versionMetaFieldId: '5c9a2c74-5a3b-43bb-8bac-60c14e5325e3',
      version: '3.0.0',
      versionIsNewer: false,
    }
  },
  mounted() {
    this.loadMetaValuesForProject();
  },
  methods: {
    loadMetaValuesForProject() {
      return this.$store.dispatch('clientLoadProjectMetaValues', {
        id: this.projectId,
        filter: 'metaFieldId eq ' + this.versionMetaFieldId,
      }).then(res => {
        if(res && res[0]) {
          this.version = res[0].value;
        }
        this.versionIsNewer = compareVersion(this.version, this.versionNumber) <= 0;
        if(this.versionIsNewer) {
          console.log('emiting....')
          this.$emit('versionIsNewer');
        }
      });
    }
  }
}
</script>